import React, { useEffect, useState } from 'react';
import { StyledProductBtn } from '@pages/Main/Common/Product/Product.style';
import { ImgWH } from '@pages/CommonStyle/common.style';
import { Trans } from 'react-i18next';
import { BlueArrowOut } from '@assets/images/icon/blue';
import { RefAButton, RefBtnLabel } from '../../Solution.style';

interface Props {
  sectionRefs: React.RefObject<HTMLDivElement>[];
}

const RefButtonBar: React.FC<Props> = ({ sectionRefs }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  // IntersectionObserver로 각 섹션 감지
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = sectionRefs.findIndex((ref) => ref.current === entry.target);
            if (index !== -1) {
              setActiveIndex(index);
            }
          }
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -50% 0px',
        threshold: 0,
      }
    );

    sectionRefs.forEach((ref) => {
      if (ref.current) observer.observe(ref.current);
    });

    return () => {
      sectionRefs.forEach((ref) => {
        if (ref.current) observer.unobserve(ref.current);
      });
    };
  }, [sectionRefs]);

  // 버튼 클릭 스크롤
  const scrollTo = (ref: React.RefObject<HTMLDivElement>) => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <StyledProductBtn onClick={() => scrollTo(sectionRefs[0])} index={0} selectedIndex={activeIndex}>
        <RefBtnLabel index={0} selectedIndex={activeIndex} size="small">
          <Trans i18nKey="solutionCommon.ref.0.text" />
        </RefBtnLabel>
      </StyledProductBtn>

      <StyledProductBtn onClick={() => scrollTo(sectionRefs[1])} index={1} selectedIndex={activeIndex}>
        <RefBtnLabel index={1} selectedIndex={activeIndex} size="small">
          <Trans i18nKey="solutionCommon.ref.1.text" />
        </RefBtnLabel>
      </StyledProductBtn>

      <StyledProductBtn onClick={() => scrollTo(sectionRefs[2])} index={2} selectedIndex={activeIndex}>
        <RefBtnLabel index={2} selectedIndex={activeIndex} size="small">
          <Trans i18nKey="solutionCommon.ref.2.text" />
        </RefBtnLabel>
      </StyledProductBtn>

      <StyledProductBtn onClick={() => scrollTo(sectionRefs[3])} index={3} selectedIndex={activeIndex}>
        <RefBtnLabel index={3} selectedIndex={activeIndex} size="small">
          <Trans i18nKey="solutionCommon.ref.3.text" />
        </RefBtnLabel>
      </StyledProductBtn>

      <RefAButton>
        <RefBtnLabel index={4} selectedIndex={activeIndex} size="small">
          <Trans i18nKey="solutionCommon.ref.4.text" />
        </RefBtnLabel>
        <ImgWH w="24" h="24" src={BlueArrowOut} />
      </RefAButton>
    </>
  );
};

export default RefButtonBar;
